import _ from "lodash";
import * as z from "../../framework";

export interface DowntimeWindow {
    startTime: number;
    endTime: number;
    displayed15MinAlert: boolean;
    displayedDayOfAlert: boolean;
    displayedWeekBeforeAlert: boolean;
}

export default class Downtime {

    downtimeWindow: DowntimeWindow;
    minorDowntimeWindow: DowntimeWindow;
    statusPageLink: string;
    readonly SERVICE_PRO_STATUS_PAGE_LINK = `<a href="https://servicepro10.status.io/">${z.ll("OurStatusPage")}</a>`;
    readonly TRIMBLE_PULSE_STATUS_PAGE_LINK = `<a href="https://pulseservice.status.io/">${z.ll("OurStatusPage")}</a>`;

    constructor() {
        let me = this;

        me.downtimeWindow = JSON.parse(sessionStorage.getItem("DowntimeWindow"));
        me.minorDowntimeWindow = JSON.parse(sessionStorage.getItem("MinorDowntimeWindow"));
        me.statusPageLink = z.settings.brandName === "servicepro" ?
            me.SERVICE_PRO_STATUS_PAGE_LINK :
            z.settings.brandName === "trimblepulse" ?
            me.TRIMBLE_PULSE_STATUS_PAGE_LINK : "";

        let downtimeWindowOption: any = _.find(JSON.parse((localStorage as any).companyData).Options,
                (o: any) => o.OptionNumber === "DowntimeWindow" && o.Value.indexOf("||") > 0),
            minorDowntimeWindowOption: any = _.find(JSON.parse((localStorage as any).companyData).Options,
                (o: any) => o.OptionNumber === "MinorDowntimeWindow" && o.Value.indexOf("||") > 0),
            isMinor = downtimeWindowOption ? false : !!minorDowntimeWindowOption,
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow;

        if (!downtimeWindow && (localStorage as any).companyData) {
            let option = isMinor ? minorDowntimeWindowOption : downtimeWindowOption,
                downtimeWindowString = option ? option.Value : null;

            if (downtimeWindowString && downtimeWindowString.indexOf("||") > -1) {
                let downtimeWindowStringSplit = downtimeWindowString.split("||"),
                    startTime = Date.parse(downtimeWindowStringSplit[0]),
                    endTime = Date.parse(downtimeWindowStringSplit[1]);

                downtimeWindow = me.setDowntimeWindow(isMinor, {
                    startTime: startTime,
                    endTime: endTime,
                    displayed15MinAlert: false,
                    displayedDayOfAlert: false,
                    displayedWeekBeforeAlert: false,
                });

                sessionStorage.setItem(`${isMinor ? "Minor" : ""}DowntimeWindow`, JSON.stringify(downtimeWindow));
            }
        }

        if (downtimeWindow) {
            me.handleDisplayAlert(isMinor);
        }
    }

    private setDowntimeWindow(isMinor: boolean, downtimeWindow: DowntimeWindow) {
        var me = this;

        if (isMinor) {
            me.minorDowntimeWindow = downtimeWindow;
        } else {
            me.downtimeWindow = downtimeWindow;
        }

        return downtimeWindow;
    }

    private handleDisplayAlert(isMinor: boolean) {
        let me = this,
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow;

        if (me.isAfterDowntime(isMinor)) {
            delete localStorage.stopAllAjaxRequests;
            return;
        } else if (me.isDuringDowntime(isMinor)) {
            me.displayDuringAlert(isMinor);
        } else if (me.is15MinOfDowntime(isMinor)) {
            let now = (new Date()).getTime(),
                offset = downtimeWindow.startTime - now;

            setTimeout(() => { me.handleDisplayAlert(isMinor); }, offset);

            if (!downtimeWindow.displayed15MinAlert) {
                me.display15MinAlert(isMinor);
            }
        } else if (me.isDayOfDowntime(isMinor)) {
            if (!downtimeWindow.displayed15MinAlert) {
                let now = (new Date()).getTime(),
                    msIn15Min = 900000,
                    offset = downtimeWindow.startTime - msIn15Min - now;

                setTimeout(() => { me.handleDisplayAlert(isMinor); }, offset);
            }

            if (!downtimeWindow.displayedDayOfAlert) {
                me.displayDayOfAlert(isMinor);
            }
        } else if (me.isWeekBeforeDowntime(isMinor)) {
            if (!downtimeWindow.displayedDayOfAlert) {
                let today = new Date(),
                    downtimeStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
                    offset = downtimeStartDate.getTime() - today.getTime();

                setTimeout(() => { me.handleDisplayAlert(isMinor); }, offset);
            }

            if (!downtimeWindow.displayedWeekBeforeAlert) {
                me.displayWeekBeforeAlert(isMinor);
            }
        } else {
            if (!downtimeWindow.displayedWeekBeforeAlert) {
                let today = new Date(),
                    downtimeStartDate = new Date(downtimeWindow.startTime),
                    downtimeStartDay = new Date(downtimeStartDate.getFullYear(), downtimeStartDate.getMonth(), downtimeStartDate.getDate()),
                    offset = downtimeStartDay.getTime() - today.getTime();

                if (offset <= 2147483647) {
                    setTimeout(() => { me.handleDisplayAlert(isMinor); }, offset);
                }
            }
        }
    }

    private isAfterDowntime(isMinor: boolean) {
        let me = this,
            now = (new Date()).getTime(),
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow;

        return now > downtimeWindow.endTime;
    }

    private isDuringDowntime(isMinor: boolean) {
        let me = this,
            now = (new Date()).getTime(),
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow;

        return now >= downtimeWindow.startTime && now <= downtimeWindow.endTime;
    }

    private is15MinOfDowntime(isMinor: boolean) {
        let me = this,
            msIn15Min = 900000,
            now = (new Date()).getTime(),
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow;

        return (downtimeWindow.startTime - now) <= msIn15Min && now <= downtimeWindow.endTime;
    }

    private isDayOfDowntime(isMinor: boolean) {
        let me = this,
            today = new Date(),
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow,
            downtimeStartDate = new Date(downtimeWindow.startTime);

        return today.getFullYear() == downtimeStartDate.getFullYear()
            && today.getMonth() == downtimeStartDate.getMonth()
            && today.getDate() == downtimeStartDate.getDate();
    }

    private isWeekBeforeDowntime(isMinor: boolean) {
        let me = this,
            today = new Date(),
            nextWeek = new Date(),
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow,
            downtimeStartDate = new Date(downtimeWindow.startTime);

        nextWeek.setDate(today.getDate() + 7);

        return (nextWeek.getTime() - downtimeStartDate.getTime()) > 0;
    }

    private displayDuringAlert(isMinor: boolean) {
        let me = this,
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow,
            llKey = `${isMinor ? "Minor" : ""}MaintenanceDuringAlertMessageStatus`,
            message = z.ll(llKey).format(
                z.LocalizedLanguage.BrandedAppName,
                z.util.kendoFormatDateTime(new Date(downtimeWindow.endTime)),
                me.statusPageLink
            );

        if (!isMinor) {
            localStorage.stopAllAjaxRequests = "true";
        }

        z.controls.alert({
            header: z.ll("MaintenanceAlert"),
            type: "warning",
            fade: false,
            message: message,
            messageIsHTML: true
        });
    }

    private display15MinAlert(isMinor: boolean) {
        let me = this,
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow,
            llKey = `${isMinor ? "Minor" : ""}Maintenance15MinUntilAlertMessageStatus`,
            message = z.ll(llKey).format(
                z.LocalizedLanguage.BrandedAppName,
                z.util.kendoFormatDateTime(new Date(downtimeWindow.startTime)),
                z.util.kendoFormatDateTime(new Date(downtimeWindow.endTime)),
                me.statusPageLink
            );

        z.controls.alert({
            header: z.ll("MaintenanceAlert"),
            type: "warning",
            fade: false,
            message: message,
            messageIsHTML: true
        });

        downtimeWindow.displayed15MinAlert = true;
        me.setDowntimeWindow(isMinor, downtimeWindow);
        sessionStorage.setItem(`${isMinor ? "Minor" : ""}DowntimeWindow`, JSON.stringify(downtimeWindow));
    }

    private displayDayOfAlert(isMinor: boolean) {
        let me = this,
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow,
            llKey = `${isMinor ? "Minor" : ""}MaintenanceDayOfAlertMessageStatus`,
            message = z.ll(llKey).format(
                z.LocalizedLanguage.BrandedAppName,
                z.util.kendoFormatDateTime(new Date(downtimeWindow.startTime)),
                z.util.kendoFormatDateTime(new Date(downtimeWindow.endTime)),
                me.statusPageLink
            );

        z.controls.alert({
            header: z.ll("MaintenanceAlert"),
            type: "warning",
            fade: false,
            message: message,
            messageIsHTML: true
        });

        downtimeWindow.displayedDayOfAlert = true;
        me.setDowntimeWindow(isMinor, downtimeWindow);
        sessionStorage.setItem(`${isMinor ? "Minor" : ""}DowntimeWindow`, JSON.stringify(downtimeWindow));
    }

    private displayWeekBeforeAlert(isMinor: boolean) {
        let me = this,
            downtimeWindow = isMinor ? me.minorDowntimeWindow : me.downtimeWindow,
            llKey = `${isMinor ? "Minor" : ""}MaintenanceWeekBeforeAlertMessageStatus`,
            message = z.ll(llKey).format(
                z.LocalizedLanguage.BrandedAppName,
                z.util.kendoFormatDateTime(new Date(downtimeWindow.startTime)),
                z.util.kendoFormatDateTime(new Date(downtimeWindow.endTime)),
                me.statusPageLink
            );

        z.controls.alert({
            header: z.ll("MaintenanceAlert"),
            type: "warning",
            fade: false,
            message: message,
            messageIsHTML: true
        });

        downtimeWindow.displayedWeekBeforeAlert = true;
        me.setDowntimeWindow(isMinor, downtimeWindow);
        sessionStorage.setItem(`${isMinor ? "Minor" : ""}DowntimeWindow`, JSON.stringify(downtimeWindow));
    }
}
